<mat-tab-group
  [selectedIndex]="activeTabIndex"
  (selectedTabChange)="onTabChange($event)"
>
  <mat-tab *ngFor="let checklistName of CheckListNames" [label]="checklistName">
    <table
      mat-table
      [dataSource]="dataSource"
      class="basic-table plant-model-table popup"
      matSort
    >
      <!-- Items Column -->
      <ng-container matColumnDef="items">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <p class="header-text Item-header">
            {{ langObj ? langObj?.Items : ("Items" | translate) }}
          </p>
        </th>
        <td
          mat-cell
          *matCellDef="let element"
          class="td-text"
          style="padding-left: 80px; width: 25%"
        >
          {{ element.itemName }}
        </td>
      </ng-container>

      <!-- Good Example Column -->
      <ng-container matColumnDef="good">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          style="padding-left: 0px"
        >
          <p class="header-text">
            {{ langObj ? langObj?.GoodExample : ("GoodExample" | translate) }}
          </p>
        </th>
        <td mat-cell *matCellDef="let element; let i = index" style="width: 8%">
          <button
            mat-mini-fab
            *ngIf="element.goodExampleImage"
            color="accent"
            (click)="openFilePopUp(element, i, 1)"
            style="background-color: #8f0fd1"
          >
            <mat-icon>remove_red_eye</mat-icon>
          </button>
        </td>
      </ng-container>

      <!-- Bad Example Column -->
      <ng-container matColumnDef="bad">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          style="padding-left: 0px"
        >
          <p class="header-text">
            {{ langObj ? langObj?.BadExample : ("BadExample" | translate) }}
          </p>
        </th>
        <td mat-cell *matCellDef="let element; let i = index" style="width: 8%">
          <button
            mat-mini-fab
            *ngIf="element.badExampleImage"
            color="accent"
            (click)="openFilePopUp(element, i, 2)"
            style="background-color: #8f0fd1"
          >
            <mat-icon>remove_red_eye</mat-icon>
          </button>
        </td>
      </ng-container>

      <!-- Standard Column -->
      <ng-container matColumnDef="standard">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <p class="header-text">
            {{ langObj ? langObj?.Standard : ("Standard" | translate) }}
          </p>
        </th>
        <td
          mat-cell
          *matCellDef="let element"
          class="wrapped-text"
          style="width: 8%; background-color: #edf1e5"
        >
          {{ element.standard }}
        </td>
      </ng-container>

      <!-- Minimum Column -->
      <ng-container matColumnDef="minimum">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <p class="header-text">
            {{ langObj ? langObj?.Min : ("Min" | translate) }}
          </p>
        </th>
        <td
          mat-cell
          *matCellDef="let element"
          class="wrapped-text"
          style="width: 5%; background-color: #edf1e5"
        >
          {{ element.minValue }}
        </td>
      </ng-container>

      <!-- Maximum Column -->
      <ng-container matColumnDef="maximum">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <p class="header-text">
            {{ langObj ? langObj?.Max : ("Max" | translate) }}
          </p>
        </th>
        <td
          mat-cell
          *matCellDef="let element"
          class="wrapped-text"
          style="width: 5%; background-color: #edf1e5"
        >
          {{ element.maxValue }}
        </td>
      </ng-container>

      <!-- Score Column -->
      <ng-container matColumnDef="score">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <p class="header-text">
            {{ langObj ? langObj?.Result : ("Result" | translate) }}
          </p>
        </th>
        <td
          mat-cell
          *matCellDef="let element"
          style="width: 15%; background-color: #edf1e5"
        >
          <mat-radio-group
            required
            aria-label="Select an option"
            [value]="element.catType"
            [(ngModel)]="element.catType"
            (change)="scoreUpdate($event, element); onChangeradio($event)"
            *ngIf="element.itemType === 1"
            [disabled]="isviewMode"
          >
            <mat-radio-button
              *ngFor="let p of categoryTypeDDL"
              [value]="p.id"
              style="margin-left: 10px"
            >
              {{ p.name }}
            </mat-radio-button>
          </mat-radio-group>

          <mat-form-field
            appearance="fill"
            class="field-fill-table"
            *ngIf="element.itemType === 2"
            style="width: 100%"
          >
            <input
              matInput
              autocomplete="off"
              [(ngModel)]="element.catType"
              (input)="scoreUpdate($event, element)"
              [value]="element.score"
              [readonly]="isviewMode"
            />
          </mat-form-field>
          <div
            *ngIf="element.itemType === 4 || element.itemType === 6"
            style="display: flex"
          >
            <button
              mat-mini-fab
              color="accent"
              (click)="openImage(element)"
              style="background-color: #8f0fd1"
            >
              <mat-icon>remove_red_eye</mat-icon>
            </button>

            <div appearance="fill" class="field-fill" style="width: 180px">
              <input
                placeholder="Upload File"
                [readonly]="isviewMode"
                [hidden]="isviewMode"
                type="file"
                (change)="uploadedFile($event, element.id, element.itemType)"
                class="form-control"
                [accept]="
                  element.itemType === 6
                    ? 'image/*'
                    : 'image/*,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document'
                "
              />
            </div>
          </div>

          <mat-form-field
            appearence="fill"
            class="field-fill"
            *ngIf="element.itemType === 3"
            style="width: 100%"
          >
            <mat-label class="placeholder-title">{{
              langObj ? langObj?.FromDate : ("FromDate" | translate)
            }}</mat-label>
            <input
              matInput
              readonly
              [(ngModel)]="element.catType"
              [matDatepicker]="pickerspoedit"
              (dateInput)="onDateChange($event, element)"
            />
            <mat-datepicker-toggle
              matSuffix
              [disabled]="isviewMode"
              [for]="pickerspoedit"
            ></mat-datepicker-toggle>
            <mat-datepicker
              #pickerspoedit
              [disabled]="isviewMode"
            ></mat-datepicker>
          </mat-form-field>
          <mat-form-field
            appearance="fill"
            class="field-fill"
            *ngIf="element.itemType === 5"
            style="width: 100%"
          >
            <mat-label>Select an option</mat-label>
            <mat-select
              disableRipple
              [disabled]="isviewMode"
              [(ngModel)]="element.catType"
              (selectionChange)="OnDropdownUpdate($event, element)"
            >
              <mat-option
                *ngFor="let data of element.dropDown"
                [value]="data.ElementValue"
              >
                {{ data.ElementValue }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </td>
      </ng-container>

      <!-- Remarks Column -->
      <ng-container matColumnDef="remarks">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <p class="header-text">
            {{ langObj ? langObj?.Remarks : ("Remarks" | translate) }}
          </p>
        </th>
        <td
          mat-cell
          *matCellDef="let element"
          style="width: 50%; background-color: #edf1e5"
        >
          <mat-form-field
            appearance="fill"
            class="field-fill-table"
            style="width: 100%"
          >
            <input
              matInput
              placeholder="Remarks"
              autocomplete="off"
              [(ngModel)]="element.remarks"
              (change)="remarksUpdate($event, element)"
              [readonly]="isviewMode"
              [value]="element.remarks"
            />
          </mat-form-field>
        </td>
      </ng-container>

      <!-- Header and Row Definitions -->
      <tr mat-header-row *matHeaderRowDef="itemColumns"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: itemColumns"
        [class.hidden]="!row.visible"
      ></tr>

      <tr class="mat-row" *matNoDataRow style="text-align: center">
        <td class="mat-cell" style="text-align: center" colspan="7">
          {{ langObj ? langObj?.nodatamatch : ("nodatamatch" | translate) }}
        </td>
      </tr>

      <!-- Group header -->
      <ng-container matColumnDef="groupHeader">
        <td
          mat-cell
          *matCellDef="let group"
          class="group-header"
          colspan="999"
          (click)="groupHeaderClick(group, checklistName)"
        >
          <div class="d-flex align-items-center">
            <mat-icon *ngIf="group.expanded">arrow_drop_down</mat-icon>
            <mat-icon *ngIf="!group.expanded">arrow_right</mat-icon>
            <span class="table-group-title">
              {{ group.itemGroup }}
            </span>
          </div>
        </td>
      </ng-container>

      <tr
        mat-header-row
        *matRowDef="let group; columns: ['groupHeader']; when: isGroup"
      ></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: ['groupHeader']; when: isGroup"
      ></tr>
    </table>
  </mat-tab>
</mat-tab-group>

<p-dialog
  [closeOnEscape]="false"
  header="File Detail"
  [(visible)]="displayMaximizable"
  [modal]="true"
  [style]="{ width: '90vw' }"
  [maximizable]="true"
  [baseZIndex]="10000"
  [draggable]="false"
  [resizable]="false"
>
  <ngx-doc-viewer
    *ngIf="fileType === 'doc'"
    [url]="doc"
    viewer="google"
    style="width: 100%; height: 90vh; margin-top: 10px"
  ></ngx-doc-viewer>
  <angular-image-viewer
    *ngIf="fileType === 'img'"
    [src]="images"
    style="width: 100%; height: 90vh; margin-top: 10px"
    [(index)]="imageIndexOne"
  ></angular-image-viewer>
</p-dialog>

<p-dialog
  [closeOnEscape]="false"
  header="File Detail"
  [(visible)]="displayUploadedFile"
  [modal]="true"
  [style]="{ width: '90vw' }"
  [maximizable]="true"
  [baseZIndex]="10000"
  [draggable]="false"
  [resizable]="false"
>
  <ngx-doc-viewer
    *ngIf="uploadedfileType === 'doc'"
    [url]="uploadeddoc"
    viewer="google"
    style="width: 100%; height: 90vh; margin-top: 10px"
  ></ngx-doc-viewer>
  <angular-image-viewer
    *ngIf="uploadedfileType === 'img'"
    [src]="uploadedimages"
    style="width: 100%; height: 90vh; margin-top: 10px"
    [(index)]="imageIndexOne"
  ></angular-image-viewer>
</p-dialog>
